import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  GlJournalDto,
  GlJournalListDto,
  GlJournalFilterDto,
  CreateGlJournalRequest,
  UpdateGlJournalRequest,
} from '@/types/glJournal.types';

export const glJournalApi = {
  /** GET /api/v1/gl-journals — paginated list */
  getList: (filter?: GlJournalFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<GlJournalListDto>>>('/gl-journals', { params: filter }),

  /** GET /api/v1/gl-journals/{id} — full journal with lines and workflow history */
  getById: (id: string) =>
    apiClient.get<ApiResponse<GlJournalDto>>(`/gl-journals/${id}`),

  /** POST /api/v1/gl-journals — create new journal */
  create: (data: CreateGlJournalRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/gl-journals', data),

  /** PUT /api/v1/gl-journals/{id} — update draft journal */
  update: (id: string, data: UpdateGlJournalRequest) =>
    apiClient.put<ApiResponse<object>>(`/gl-journals/${id}`, data),

  /** POST /api/v1/gl-journals/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/gl-journals/${id}/submit`),

  /** POST /api/v1/gl-journals/{id}/approve — approve the journal */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/gl-journals/${id}/approve`, { remarks }),

  /** POST /api/v1/gl-journals/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/gl-journals/${id}/reject`, { reason }),

  /** POST /api/v1/gl-journals/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/gl-journals/${id}/post`),

  /** POST /api/v1/gl-journals/{id}/reverse — create reversal journal */
  reverse: (id: string, reversalDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/gl-journals/${id}/reverse`, {
      reversalDate,
      narration,
    }),

  /** POST /api/v1/gl-journals/{id}/cancel — cancel the journal */
  cancel: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/gl-journals/${id}/cancel`, { reason }),
};
